import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, shareReplay } from 'rxjs';
import { environment } from '@environments/environment';
import { APIResponse } from '@data/api-response';
import { ProfileResponse } from '@shared/types/profile.type';
import { JWTTokenResponse } from '@shared/types/jwt.type';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  readonly baseUrl = `${environment.apiBaseUrl}`;
  readonly commonPatientUrl = `${this.baseUrl}/profiles`;
  readonly userSessionUpdateUrl = `${this.baseUrl}/user-sessions`;
  private readonly headerInfoSubject = new BehaviorSubject<any>(null);
  headerInfo$ = this.headerInfoSubject.asObservable();
  readonly http = inject(HttpClient);

  private profileCache$?: Observable<APIResponse<ProfileResponse>>;

  getProfile(): Observable<APIResponse<ProfileResponse>> {
    if (!this.profileCache$) {
      const url = `${environment.apiBaseUrl}/profiles`;
      this.profileCache$ = this.http.get<APIResponse<ProfileResponse>>(url).pipe(shareReplay(1));
    }
    return this.profileCache$;
  }

  logoutUser(): Observable<APIResponse<any>> {
    return this.http.post<APIResponse<any>>(`${environment.logoutUrl}`, {});
  }

  clearProfileCache() {
    this.profileCache$ = undefined;
  }

  setHeaderInfo(info: any) {
    this.headerInfoSubject.next(info);
  }

  updateUserSession(selectedAccountId: number): Observable<APIResponse<any>> {
    return this.http.put<APIResponse<any>>(`${this.userSessionUpdateUrl}`, { custShipToId: selectedAccountId });
  }

  getUpdatedJWTToken(id_token: string, access_token: string) {
    const headers = { 'Authorization': id_token + ', ' + access_token };
    return this.http.post<JWTTokenResponse>(`${environment.jwtForOktab2bUrl}`, {}, { headers });
  }
}
